import React from "react";
import image from "../../../assets/Vibee1.png";
import image2 from "../../../assets/NoPath.png";
import image3 from "../../../assets/NoPath2.png";
import image4 from "../../../assets/NoPath4.png";
import image5 from "../../../assets/NoPath5.png";

import background from "../../../assets/background.png";
import rider from "../../../assets/rider.png";
import mob1 from "../../../assets/1.png";
import mob2 from "../../../assets/2.png";
import mob3 from "../../../assets/3.png";

import map from "../../../assets/map.png";
import V from "../../../assets/V.png";

import Group2 from "../../../assets/Group2.png";
import Group1 from "../../../assets/Group1.png";
import Group3 from "../../../assets/Group3.png";

import E from "../../../assets/E.png";
import group4 from "../../../assets/group11614.png";
import vibe_logo from "../../../assets/vibe-logo.png";

import upperVibe from "../../../assets/upper_vibe.png";
import google from "../../../assets/google_play.png";
import apple from "../../../assets/app_store.png";
import pack from "../../../assets/pack.png";
import shampoo from "../../../assets/shampoo.png";
import harpic from "../../../assets/harpic.png";
import powder from "../../../assets/powder.png";
import usb from "../../../assets/usb.png";
import perfume from "../../../assets/perfume.png";
import food from "../../../assets/food.png";
import polish from "../../../assets/polish.png";

import B from "../../../assets/B.png";

const MainPage = () => {
  return (
    <div className="main_div">
      <div className="image_container">
        <img src={image} alt="Vibe" className="c-VIBE-7" />
        <span className="Discover-convenience-at-your-fingertips-with-Vibe">
          Discover convenience at your fingertips with Vibe!
        </span>
      </div>
      <div className="Category_div">
        <span className="Categories">Categories</span>
      </div>

      <div className="CategoryContainer">
        <img src={V} alt="" className="V_image" />
        <div className="categories_container">
          <div className="category_item">
            <img src={image2} alt="NoPath" className="NoPath" />
            <div class="Snacks ">Snack</div>
          </div>
          <div className="category_item">
            <img src={image3} alt="NoPath" className="NoPath2" />
            <div class="Snacks ">Snack</div>
          </div>
          <div className="category_item">
            <img src={image4} alt="NoPath" className="NoPath---Copy" />
            <div class="Snacks ">Snack</div>
          </div>
          <div className="category_item">
            <img src={image5} alt="NoPath" className="NoPath3" />
            <div class="Snacks ">Snack</div>
          </div>

          <div className="category_item">
            <img src={shampoo} alt="NoPath" className="NoPath6" />
            <div class="Snacks ">Snack</div>
          </div>
          <div className="category_item">
            <img src={pack} alt="NoPath" className="NoPath6" />
            <div class="Snacks ">Snack</div>
          </div>
          <div className="category_item">
            <img src={harpic} alt="NoPath" className="NoPath6" />
            <div class="Snacks ">Snack</div>
          </div>
          <div className="category_item">
            <img src={powder} alt="NoPath" className="NoPath6" />
            <div class="Snacks ">Snack</div>
          </div>

          <div className="category_item">
            <img src={usb} alt="NoPath" className="NoPath6" />
            <div class="Snacks ">Snack</div>
          </div>
          <div className="category_item">
            <img src={perfume} alt="NoPath" className="NoPath6" />
            <div class="Snacks ">Snack</div>
          </div>
          <div className="category_item">
            <img src={food} alt="NoPath" className="NoPath6" />
            <div class="Snacks ">Snack</div>
          </div>
          <div className="category_item">
            <img src={polish} alt="NoPath" className="NoPath6" />
            <div class="Snacks ">Snack</div>
          </div>
        </div>
      </div>
      <div className="c-VIBE-8">
        <div className="left">
          <div>
            <p className="Pick-up-Delivery">Pick-up & Delivery</p>
            <span className="Choose-your-convenience">
              Choose your convenience. Get your goodies on the go or delivered
              right to your doorstep, whatever suits your vibe.
            </span>
          </div>
        </div>
        <div className="right">
          <img src={rider} alt="rider" className="c-VIBE-9" />
        </div>
      </div>

      <section className="ui-showcase">
        <h2 className="ui-showcase__title">User-Friendly Interface</h2>
        <div className="ui-showcase__stage">
          <img src={B} alt="" aria-hidden="true" className="ui-showcase__bg" />
          <div className="ui-showcase__phones">
            <img src={mob1} alt="Vibe app home screen" />
            <img src={mob2} alt="Vibe app add to cart screen" />
            <img src={mob3} alt="Vibe app order confirmation screen" />
          </div>
        </div>
      </section>

      <div className="With-a-few-taps-your-order-is-on-its-way-Enjoy-a-seamless-experience-from-browsing-to-checkout-designed-with-you-in-mind">
        <div className="child_class">
          With a few taps, your order is on its way. Enjoy a seamless experience
          from browsing to checkout, designed with you in mind.
        </div>
      </div>
      <div className="container1">
        <div className="background_image">
          <div className="map_section">
            <img src={map} alt="map" className="map_image" />
          </div>
          <div className="text_section">
            <div className="Discover-Vibe-in-your-city">
              <span>Discover Vibe</span>
              <span> in your city!</span>
            </div>
            <div className="Now-Serving-Karachi-Islamabad-and-Peshawar-Stay-tuned-Vibe-is-expanding-to-more-cities-soon">
              Now Serving
              <br></br>
              <span className="text-style-1"> Karachi</span>,
              <span className="text-style-2"> Islamabad</span>, and
              <span className="text-style-3"> Peshawar</span>!<br></br>
              Stay tuned! Vibe is expanding to <br></br> more cities soon.
            </div>
          </div>
        </div>
      </div>
      <section className="app-banner">
        <div className="app-banner__art">
          <img src={upperVibe} alt="Vibe app preview" />
        </div>

        <div className="app-banner__content">
          <img src={vibe_logo} alt="Vibe" className="app-banner__logo" />
          <h2 className="app-banner__title">Download Application</h2>
          <div className="app-banner__badges">
            <a
              href="https://play.google.com/store/apps/details?id=com.vibe_app&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={google} alt="Get it on Google Play" />
            </a>
            <a
              href="https://apps.apple.com/pk/app/vibe-pso/id6503432941"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={apple} alt="Download on the App Store" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MainPage;
